import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const problemsSlice = createSlice({
  name: "entities/patient-stats/problems-slice",
  initialState,
  reducers: {
    setProblems: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setProblems } = problemsSlice.actions;

export default problemsSlice.reducer;
